import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getRole } from '@completion/selectors';
import { ProjectAccessRoles } from '@completion/models';

@Injectable({
  providedIn: 'root',
})
export class RoadmapGuard implements CanActivate {
  constructor(
    private readonly store: Store,
    private readonly router: Router,
  ) {}

  canActivate(): Observable<boolean> {
    return this.store.select(getRole).pipe(
      map((role) => {
        const allowed = role === ProjectAccessRoles.ADMIN || role === ProjectAccessRoles.EDITOR;
        if (!allowed) {
          this.router.navigateByUrl('/dashboard');
        }
        return allowed;
      }),
    );
  }
}
